type IconProps = React.HTMLAttributes<SVGElement>;

export const LandingIcons = {
  logo: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect width="7" height="7" x="14" y="3" rx="1" />
      <path d="M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3" />
    </svg>
  ),
  twitter: (props: IconProps) => (
    <svg
      {...props}
      height="23"
      viewBox="0 0 1200 1227"
      width="23"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
    </svg>
  ),
  github: (props: IconProps) => (
    <svg viewBox="0 0 438.549 438.549" {...props}>
      <path
        fill="currentColor"
        d="M409.132 114.573c-19.608-33.596-46.205-60.194-79.798-79.8-33.598-19.607-70.277-29.408-110.063-29.408-39.781 0-76.472 9.804-110.063 29.408-33.596 19.605-60.192 46.204-79.8 79.8C9.803 148.168 0 184.854 0 224.63c0 47.78 13.94 90.745 41.827 128.906 27.884 38.164 63.906 64.572 108.063 79.227 5.14.954 8.945.283 11.419-1.996 2.475-2.282 3.711-5.14 3.711-8.562 0-.571-.049-5.708-.144-15.417a2549.81 2549.81 0 01-.144-25.406l-6.567 1.136c-4.187.767-9.469 1.092-15.846 1-6.374-.089-12.991-.757-19.842-1.999-6.854-1.231-13.229-4.086-19.13-8.559-5.898-4.473-10.085-10.328-12.56-17.556l-2.855-6.57c-1.903-4.374-4.899-9.233-8.992-14.559-4.093-5.331-8.232-8.945-12.419-10.848l-1.999-1.431c-1.332-.951-2.568-2.098-3.711-3.429-1.142-1.331-1.997-2.663-2.568-3.997-.572-1.335-.098-2.43 1.427-3.289 1.525-.859 4.281-1.276 8.28-1.276l5.708.853c3.807.763 8.516 3.042 14.133 6.851 5.614 3.806 10.229 8.754 13.846 14.842 4.38 7.806 9.657 13.754 15.846 17.847 6.184 4.093 12.419 6.136 18.699 6.136 6.28 0 11.704-.476 16.274-1.423 4.565-.952 8.848-2.383 12.847-4.285 1.713-12.758 6.377-22.559 13.988-29.41-10.848-1.14-20.601-2.857-29.264-5.14-8.658-2.286-17.605-5.996-26.835-11.14-9.235-5.137-16.896-11.516-22.985-19.126-6.09-7.614-11.088-17.61-14.987-29.979-3.901-12.374-5.852-26.648-5.852-42.826 0-23.035 7.52-42.637 22.557-58.817-7.044-17.318-6.379-36.732 1.997-58.24 5.52-1.715 13.706-.428 24.554 3.853 10.85 4.283 18.794 7.952 23.84 10.994 5.046 3.041 9.089 5.618 12.135 7.708 17.705-4.947 35.976-7.421 54.818-7.421s37.117 2.474 54.823 7.421l10.849-6.849c7.419-4.57 16.18-8.758 26.262-12.565 10.088-3.805 17.802-4.853 23.134-3.138 8.562 21.509 9.325 40.922 2.279 58.24 15.036 16.18 22.559 35.787 22.559 58.817 0 16.178-1.958 30.497-5.853 42.966-3.9 12.471-8.941 22.457-15.125 29.979-6.191 7.521-13.901 13.85-23.131 18.986-9.232 5.14-18.182 8.85-26.84 11.136-8.662 2.286-18.415 4.004-29.263 5.146 9.894 8.562 14.842 22.077 14.842 40.539v60.237c0 3.422 1.19 6.279 3.572 8.562 2.379 2.279 6.136 2.95 11.276 1.995 44.163-14.653 80.185-41.062 108.068-79.226 27.88-38.161 41.825-81.126 41.825-128.906-.01-39.771-9.818-76.454-29.414-110.049z"
      ></path>
    </svg>
  ),
  radix: (props: IconProps) => (
    <svg viewBox="0 0 25 25" fill="none" {...props}>
      <path
        d="M12 25C7.58173 25 4 21.4183 4 17C4 12.5817 7.58173 9 12 9V25Z"
        fill="currentcolor"
      ></path>
      <path d="M12 0H4V8H12V0Z" fill="currentcolor"></path>
      <path
        d="M17 8C19.2091 8 21 6.20914 21 4C21 1.79086 19.2091 0 17 0C14.7909 0 13 1.79086 13 4C13 6.20914 14.7909 8 17 8Z"
        fill="currentcolor"
      ></path>
    </svg>
  ),
  aria: (props: IconProps) => (
    <svg role="img" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M13.966 22.624l-1.69-4.281H8.122l3.892-9.144 5.662 13.425zM8.884 1.376H0v21.248zm15.116 0h-8.884L24 22.624Z" />
    </svg>
  ),
  npm: (props: IconProps) => (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M1.763 0C.786 0 0 .786 0 1.763v20.474C0 23.214.786 24 1.763 24h20.474c.977 0 1.763-.786 1.763-1.763V1.763C24 .786 23.214 0 22.237 0zM5.13 5.323l13.837.019-.009 13.836h-3.464l.01-10.382h-3.456L12.04 19.17H5.113z"
        fill="currentColor"
      />
    </svg>
  ),
  yarn: (props: IconProps) => (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M12 0C5.375 0 0 5.375 0 12s5.375 12 12 12 12-5.375 12-12S18.625 0 12 0zm.768 4.105c.183 0 .363.053.525.157.125.083.287.185.755 1.154.31-.088.468-.042.551-.019.204.056.366.19.463.375.477.917.542 2.553.334 3.605-.241 1.232-.755 2.029-1.131 2.576.324.329.778.899 1.117 1.825.278.774.31 1.478.273 2.015a5.51 5.51 0 0 0 .602-.329c.593-.366 1.487-.917 2.553-.931.714-.009 1.269.445 1.353 1.103a1.23 1.23 0 0 1-.945 1.362c-.649.158-.95.278-1.821.843-1.232.797-2.539 1.242-3.012 1.39a1.686 1.686 0 0 1-.704.343c-.737.181-3.266.315-3.466.315h-.046c-.783 0-1.214-.241-1.45-.491-.658.329-1.51.19-2.122-.134a1.078 1.078 0 0 1-.58-1.153 1.243 1.243 0 0 1-.153-.195c-.162-.25-.528-.936-.454-1.946.056-.723.556-1.367.88-1.71a5.522 5.522 0 0 1 .408-2.256c.306-.727.885-1.348 1.32-1.737-.32-.537-.644-1.367-.329-2.21.227-.602.412-.936.82-1.08h-.005c.199-.074.389-.153.486-.259a3.418 3.418 0 0 1 2.298-1.103c.037-.093.079-.185.125-.283.31-.658.639-1.029 1.024-1.168a.94.94 0 0 1 .328-.06zm.006.7c-.507.016-1.001 1.519-1.001 1.519s-1.27-.204-2.266.871c-.199.218-.468.334-.746.44-.079.028-.176.023-.417.672-.371.991.625 2.094.625 2.094s-1.186.839-1.626 1.881c-.486 1.144-.338 2.261-.338 2.261s-.843.732-.899 1.487c-.051.663.139 1.2.343 1.515.227.343.51.176.51.176s-.561.653-.037.931c.477.25 1.283.394 1.71-.037.31-.31.371-1.001.486-1.283.028-.065.12.111.209.199.097.093.264.195.264.195s-.755.324-.445 1.066c.102.246.468.403 1.066.398.222-.005 2.664-.139 3.313-.296.375-.088.505-.283.505-.283s1.566-.431 2.998-1.357c.917-.598 1.293-.76 2.034-.936.612-.148.57-1.098-.241-1.084-.839.009-1.575.44-2.196.825-1.163.718-1.742.672-1.742.672l-.018-.032c-.079-.13.371-1.293-.134-2.678-.547-1.515-1.413-1.881-1.344-1.997.297-.5 1.038-1.297 1.334-2.78.176-.899.13-2.377-.269-3.151-.074-.144-.732.241-.732.241s-.616-1.371-.788-1.483a.271.271 0 0 0-.157-.046z"
        fill="currentColor"
      />
    </svg>
  ),
  pnpm: (props: IconProps) => (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M0 0v7.5h7.5V0zm8.25 0v7.5h7.498V0zm8.25 0v7.5H24V0zM8.25 8.25v7.5h7.498v-7.5zm8.25 0v7.5H24v-7.5zM0 16.5V24h7.5v-7.5zm8.25 0V24h7.498v-7.5zm8.25 0V24H24v-7.5z"
        fill="currentColor"
      />
    </svg>
  ),
  react: (props: IconProps) => (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236zm2.648-10.69c-1.346 0-3.107.96-4.888 2.622-1.78-1.653-3.542-2.602-4.887-2.602-.41 0-.783.093-1.106.278-1.375.793-1.683 3.264-.973 6.365C1.98 8.917 0 10.42 0 12.004c0 1.59 1.99 3.097 5.043 4.03-.704 3.113-.39 5.588.988 6.38.32.187.69.275 1.102.275 1.345 0 3.107-.96 4.888-2.624 1.78 1.654 3.542 2.603 4.887 2.603.41 0 .783-.09 1.106-.275 1.374-.792 1.683-3.263.973-6.365C22.02 15.096 24 13.59 24 12.004c0-1.59-1.99-3.097-5.043-4.032.704-3.11.39-5.587-.988-6.38-.318-.184-.688-.277-1.092-.278zm-.005 1.09v.006c.225 0 .406.044.558.127.666.382.955 1.835.73 3.704-.054.46-.142.945-.25 1.44-.96-.236-2.006-.417-3.107-.534-.66-.905-1.345-1.727-2.035-2.447 1.592-1.48 3.087-2.292 4.105-2.295zm-9.77.02c1.012 0 2.514.808 4.11 2.28-.686.72-1.37 1.537-2.02 2.442-1.107.117-2.154.298-3.113.538-.112-.49-.195-.964-.254-1.42-.23-1.868.054-3.32.714-3.707.19-.09.4-.127.563-.132zm4.882 3.05c.455.468.91.992 1.36 1.564-.44-.02-.89-.034-1.345-.034-.46 0-.915.01-1.36.034.44-.572.895-1.096 1.345-1.565zM12 8.1c.74 0 1.477.034 2.202.093.406.582.802 1.203 1.183 1.86.372.64.71 1.29 1.018 1.946-.308.655-.646 1.31-1.013 1.95-.38.66-.773 1.288-1.18 1.87-.728.063-1.466.098-2.21.098-.74 0-1.477-.035-2.202-.093-.406-.582-.802-1.204-1.183-1.86-.372-.64-.71-1.29-1.018-1.946.303-.657.646-1.313 1.013-1.954.38-.66.773-1.286 1.18-1.868.728-.064 1.466-.098 2.21-.098zm-3.635.254c-.24.377-.48.763-.704 1.16-.225.39-.435.782-.635 1.174-.265-.656-.49-1.31-.676-1.947.64-.15 1.315-.283 2.015-.386zm7.26 0c.695.103 1.365.23 2.006.387-.18.632-.405 1.282-.66 1.933-.2-.39-.41-.783-.64-1.174-.225-.392-.465-.774-.705-1.146zm3.063.675c.484.15.944.317 1.375.498 1.732.74 2.852 1.708 2.852 2.476-.005.768-1.125 1.74-2.857 2.475-.42.18-.88.342-1.355.493-.28-.958-.646-1.956-1.1-2.98.45-1.017.81-2.01 1.085-2.964zm-13.395.004c.278.96.645 1.957 1.1 2.98-.45 1.017-.812 2.01-1.086 2.964-.484-.15-.944-.318-1.37-.5-1.732-.737-2.852-1.706-2.852-2.474 0-.768 1.12-1.742 2.852-2.476.42-.18.88-.342 1.356-.494zm11.678 4.28c.265.657.49 1.312.676 1.948-.64.157-1.316.29-2.016.39.24-.375.48-.762.705-1.158.225-.39.435-.788.636-1.18zm-9.945.02c.2.392.41.783.64 1.175.23.39.465.772.705 1.143-.695-.102-1.365-.23-2.006-.386.18-.63.406-1.282.66-1.933zM17.92 16.32c.112.493.2.968.254 1.423.23 1.868-.054 3.32-.714 3.708-.147.09-.338.128-.563.128-1.012 0-2.514-.807-4.11-2.28.686-.72 1.37-1.536 2.02-2.44 1.107-.118 2.154-.3 3.113-.54zm-11.83.01c.96.234 2.006.415 3.107.532.66.905 1.345 1.727 2.035 2.446-1.595 1.483-3.092 2.295-4.11 2.295-.22-.005-.406-.05-.553-.132-.666-.38-.955-1.834-.73-3.703.054-.46.142-.944.25-1.438zm4.56.64c.44.02.89.034 1.345.034.46 0 .915-.01 1.36-.034-.44.572-.895 1.095-1.345 1.565-.455-.47-.91-.993-1.36-1.565z"
        fill="currentColor"
      />
    </svg>
  ),
  tailwind: (props: IconProps) => (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M12.001,4.8c-3.2,0-5.2,1.6-6,4.8c1.2-1.6,2.6-2.2,4.2-1.8c0.913,0.228,1.565,0.89,2.288,1.624 C13.666,10.618,15.027,12,18.001,12c3.2,0,5.2-1.6,6-4.8c-1.2,1.6-2.6,2.2-4.2,1.8c-0.913-0.228-1.565-0.89-2.288-1.624 C16.337,6.182,14.976,4.8,12.001,4.8z M6.001,12c-3.2,0-5.2,1.6-6,4.8c1.2-1.6,2.6-2.2,4.2-1.8c0.913,0.228,1.565,0.89,2.288,1.624 c1.177,1.194,2.538,2.576,5.512,2.576c3.2,0,5.2-1.6,6-4.8c-1.2,1.6-2.6,2.2-4.2,1.8c-0.913-0.228-1.565-0.89-2.288-1.624 C10.337,13.382,8.976,12,6.001,12z"
        fill="currentColor"
      />
    </svg>
  ),
  google: (props: IconProps) => (
    <svg role="img" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"
      />
    </svg>
  ),
  apple: (props: IconProps) => (
    <svg role="img" viewBox="0 0 24 24" {...props}>
      <path
        d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"
        fill="currentColor"
      />
    </svg>
  ),
  paypal: (props: IconProps) => (
    <svg role="img" viewBox="0 0 24 24" {...props}>
      <path
        d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h7.46c2.57 0 4.578.543 5.69 1.81 1.01 1.15 1.304 2.42 1.012 4.287-.023.143-.047.288-.077.437-.983 5.05-4.349 6.797-8.647 6.797h-2.19c-.524 0-.968.382-1.05.9l-1.12 7.106zm14.146-14.42a3.35 3.35 0 0 0-.607-.541c-.013.076-.026.175-.041.254-.93 4.778-4.005 7.201-9.138 7.201h-2.19a.563.563 0 0 0-.556.479l-1.187 7.527h-.506l-.24 1.516a.56.56 0 0 0 .554.647h3.882c.46 0 .85-.334.922-.788.06-.26.76-4.852.816-5.09a.932.932 0 0 1 .923-.788h.58c3.76 0 6.705-1.528 7.565-5.946.36-1.847.174-3.388-.777-4.471z"
        fill="currentColor"
      />
    </svg>
  ),
  spinner: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
  ),
  arrow: (props: IconProps) => (
    <svg
      width="5"
      height="8"
      viewBox="0 0 5 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.66669 6.66666L3.62625 4.7071C4.01677 4.31658 4.01677 3.68341 3.62625 3.29289L1.66669 1.33333"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  craft: (props: IconProps) => (
    <svg
      className="h-full w-full"
      viewBox="33 20 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g filter="url(#filter0_dddi_3_3484)">
        <rect
          x="33"
          y="20"
          width="46"
          height="46"
          rx="23"
          fill="white"
          fillOpacity="0.13"
          shapeRendering="crispEdges"
        />
        <rect
          x="33"
          y="20"
          width="46"
          height="46"
          rx="23"
          fill="url(#paint0_radial_3_3484)"
          fillOpacity="0.24"
          shapeRendering="crispEdges"
        />
        <rect
          x="33.4848"
          y="20.4848"
          width="45.0303"
          height="45.0303"
          rx="22.5152"
          stroke="url(#paint1_linear_3_3484)"
          strokeOpacity="0.42"
          strokeWidth="0.969697"
          shapeRendering="crispEdges"
        />
        <path
          d="M61.1371 39L61.8442 38.2929C61.6567 38.1054 61.4023 38 61.1371 38C60.8719 38 60.6175 38.1054 60.43 38.2929L61.1371 39ZM65.002 42.8649L65.7091 43.572C66.0996 43.1814 66.0996 42.5483 65.7091 42.1578L65.002 42.8649ZM55.8668 52V53H56.281L56.5739 52.7071L55.8668 52ZM52.002 52H51.002V53H52.002V52ZM52.002 48.1351L51.2948 47.428L51.002 47.7209V48.1351H52.002ZM48.002 34H47.002V36H48.002V34ZM64.002 36H65.002V34H64.002V36ZM48.002 38H47.002V40H48.002V38ZM54.502 40H55.502V38H54.502V40ZM48 42H47V44H48V42ZM51.0022 44H52.0022V42H51.0022V44ZM60.43 39.7071L64.2948 43.572L65.7091 42.1578L61.8442 38.2929L60.43 39.7071ZM55.8668 51H52.002V53H55.8668V51ZM53.002 52V48.1351H51.002V52H53.002ZM48.002 36H64.002V34H48.002V36ZM48.002 40H54.502V38H48.002V40ZM48 44H51.0022V42H48V44ZM52.7091 48.8422L61.8442 39.7071L60.43 38.2929L51.2948 47.428L52.7091 48.8422ZM64.2948 42.1578L55.1597 51.2929L56.5739 52.7071L65.7091 43.572L64.2948 42.1578Z"
          fill="url(#paint2_radial_3_3484)"
        />
      </g>
      <defs>
        <filter
          id="filter0_dddi_3_3484"
          x="0.0303049"
          y="0.12"
          width="111.939"
          height="122.122"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="10.88"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_3_3484"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3_3484"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="5.88"
            operator="dilate"
            in="SourceAlpha"
            result="effect2_dropShadow_3_3484"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_3_3484"
            result="effect2_dropShadow_3_3484"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="9.69697"
            operator="erode"
            in="SourceAlpha"
            result="effect3_dropShadow_3_3484"
          />
          <feOffset dy="23.2727" />
          <feGaussianBlur stdDeviation="21.3333" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_3_3484"
            result="effect3_dropShadow_3_3484"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect3_dropShadow_3_3484"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.87879" />
          <feGaussianBlur stdDeviation="4.84848" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.07 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect4_innerShadow_3_3484"
          />
        </filter>
        <radialGradient
          id="paint0_radial_3_3484"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(64.0296 13.1667) rotate(98.6417) scale(53.44 54.0429)"
        >
          <stop stopColor="white" />
          <stop offset="0.568392" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_3_3484"
          x1="56"
          y1="20"
          x2="56"
          y2="66"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_3_3484"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(56.501 34.1905) rotate(90) scale(29.5476 29.551)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.06" />
        </radialGradient>
      </defs>
    </svg>
  ),
  deploy: (props: IconProps) => (
    <svg
      className="h-full w-full"
      viewBox="33 20 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g filter="url(#filter0_dddi_3_3497)">
        <rect
          x="33"
          y="20"
          width="46"
          height="46"
          rx="23"
          fill="#363436"
          fillOpacity="0.5"
          shapeRendering="crispEdges"
        />
        <rect
          x="33.4848"
          y="20.4848"
          width="45.0303"
          height="45.0303"
          rx="22.5152"
          stroke="url(#paint0_linear_3_3497)"
          strokeOpacity="0.42"
          strokeWidth="0.969697"
          shapeRendering="crispEdges"
        />
        <path
          d="M48 44L53 34H62L59 39H65L51.5 51L53 44H48Z"
          stroke="url(#paint1_radial_3_3497)"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_dddi_3_3497"
          x="0.0303049"
          y="0.12"
          width="111.939"
          height="122.122"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="10.88"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_3_3497"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3_3497"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="5.88"
            operator="dilate"
            in="SourceAlpha"
            result="effect2_dropShadow_3_3497"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_3_3497"
            result="effect2_dropShadow_3_3497"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="9.69697"
            operator="erode"
            in="SourceAlpha"
            result="effect3_dropShadow_3_3497"
          />
          <feOffset dy="23.2727" />
          <feGaussianBlur stdDeviation="21.3333" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_3_3497"
            result="effect3_dropShadow_3_3497"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect3_dropShadow_3_3497"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.87879" />
          <feGaussianBlur stdDeviation="4.84848" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.07 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect4_innerShadow_3_3497"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3_3497"
          x1="56"
          y1="20"
          x2="56"
          y2="66"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_3_3497"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(56.5 33.1905) rotate(90) scale(29.5476)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.06" />
        </radialGradient>
      </defs>
    </svg>
  ),
  assess: (props: IconProps) => (
    <svg
      className="h-full w-full"
      viewBox="33 20 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g filter="url(#filter0_dddi_3_3506)">
        <rect
          x="33"
          y="20"
          width="46"
          height="46"
          rx="23"
          fill="#363436"
          fillOpacity="0.5"
          shapeRendering="crispEdges"
        />
        <rect
          x="33.4848"
          y="20.4848"
          width="45.0303"
          height="45.0303"
          rx="22.5152"
          stroke="url(#paint0_linear_3_3506)"
          strokeOpacity="0.42"
          strokeWidth="0.969697"
          shapeRendering="crispEdges"
        />
        <path
          d="M59 41H53M56 45H53M47 51H60C62.7614 51 65 48.7614 65 46V40C65 37.2386 62.7614 35 60 35H52C49.2386 35 47 37.2386 47 40V51Z"
          stroke="url(#paint1_radial_3_3506)"
          strokeWidth="2"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <filter
          id="filter0_dddi_3_3506"
          x="0.0303049"
          y="0.12"
          width="111.939"
          height="122.122"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="10.88"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_3_3506"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3_3506"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="5.88"
            operator="dilate"
            in="SourceAlpha"
            result="effect2_dropShadow_3_3506"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_3_3506"
            result="effect2_dropShadow_3_3506"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="9.69697"
            operator="erode"
            in="SourceAlpha"
            result="effect3_dropShadow_3_3506"
          />
          <feOffset dy="23.2727" />
          <feGaussianBlur stdDeviation="21.3333" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_3_3506"
            result="effect3_dropShadow_3_3506"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect3_dropShadow_3_3506"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.87879" />
          <feGaussianBlur stdDeviation="4.84848" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.07 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect4_innerShadow_3_3506"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3_3506"
          x1="56"
          y1="20"
          x2="56"
          y2="66"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_3_3506"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(56 34.2381) rotate(90) scale(27.8095 31.2857)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.06" />
        </radialGradient>
      </defs>
    </svg>
  ),
  features: (props: IconProps) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.03773 3.42657L4.78316 3.36783C4.38669 3.27633 3.97105 3.39554 3.68334 3.68325C3.39562 3.97097 3.27642 4.38661 3.36791 4.78308L3.42666 5.03764C3.58112 5.70699 3.30511 6.40207 2.73354 6.78311L2.34643 7.04119C2.02588 7.25489 1.83334 7.61466 1.83334 7.99992C1.83334 8.38518 2.02588 8.74495 2.34643 8.95865L2.73354 9.21672C3.30511 9.59777 3.58112 10.2928 3.42666 10.9622L3.36791 11.2168C3.27642 11.6132 3.39562 12.0289 3.68334 12.3166C3.97105 12.6043 4.38669 12.7235 4.78316 12.632L5.03773 12.5733C5.70708 12.4188 6.40215 12.6948 6.7832 13.2664L7.04127 13.6535C7.25497 13.974 7.61474 14.1666 8 14.1666C8.38526 14.1666 8.74503 13.974 8.95873 13.6535L9.21681 13.2664C9.59785 12.6948 10.2929 12.4188 10.9623 12.5733L11.2168 12.632C11.6133 12.7235 12.029 12.6043 12.3167 12.3166C12.6044 12.0289 12.7236 11.6132 12.6321 11.2168L12.5733 10.9622C12.4189 10.2928 12.6949 9.59777 13.2665 9.21672L13.6536 8.95865C13.9741 8.74495 14.1667 8.38518 14.1667 7.99992C14.1667 7.61466 13.9741 7.25489 13.6536 7.04119L13.2665 6.78311C12.6949 6.40207 12.4189 5.70699 12.5733 5.03764L12.6321 4.78308C12.7236 4.3866 12.6044 3.97097 12.3167 3.68325C12.029 3.39554 11.6133 3.27633 11.2168 3.36783L10.9623 3.42657C10.2929 3.58104 9.59785 3.30503 9.21681 2.73346L8.95873 2.34635C8.74503 2.02579 8.38526 1.83325 8 1.83325C7.61474 1.83325 7.25497 2.02579 7.04127 2.34635L6.7832 2.73346C6.40215 3.30503 5.70708 3.58104 5.03773 3.42657Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M9.83334 7.99992C9.83334 9.01244 9.01252 9.83325 8 9.83325C6.98748 9.83325 6.16667 9.01244 6.16667 7.99992C6.16667 6.9874 6.98748 6.16659 8 6.16659C9.01252 6.16659 9.83334 6.9874 9.83334 7.99992Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  ),
  testimonial: (props: IconProps) => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.833313 4.83333C0.833313 2.99238 2.3257 1.5 4.16665 1.5H9.83331C11.6743 1.5 13.1666 2.99238 13.1666 4.83333V9.16667C13.1666 11.0076 11.6743 12.5 9.83331 12.5H0.833313V4.83333Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  demo: (props: IconProps) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.33334 8.50023L7.33334 9.50023L9.66667 7.16689M5.61584 3.19034L4.82823 3.0654C4.15776 2.95905 3.54825 3.47049 3.53657 4.14924L3.52284 4.94657C3.51621 5.33182 3.31147 5.68645 2.98115 5.88482L2.2975 6.29537C1.71552 6.64487 1.57736 7.42844 2.0047 7.9559L2.50671 8.57552C2.74926 8.8749 2.82037 9.27817 2.69484 9.64245L2.43503 10.3964C2.21386 11.0382 2.61169 11.7273 3.2781 11.8566L4.06094 12.0086C4.43919 12.082 4.75287 12.3453 4.89087 12.705L5.17647 13.4496C5.4196 14.0834 6.16727 14.3555 6.76093 14.0263L7.4583 13.6395C7.79526 13.4526 8.20474 13.4526 8.5417 13.6395L9.23907 14.0263C9.83273 14.3555 10.5804 14.0834 10.8235 13.4496L11.1091 12.705C11.2471 12.3453 11.5608 12.082 11.9391 12.0086L12.7219 11.8566C13.3883 11.7273 13.7861 11.0382 13.565 10.3964L13.3052 9.64245C13.1796 9.27817 13.2507 8.8749 13.4933 8.57552L13.9953 7.9559C14.4226 7.42844 14.2845 6.64487 13.7025 6.29537L13.0189 5.88482C12.6885 5.68645 12.4838 5.33182 12.4772 4.94657L12.4634 4.14924C12.4517 3.47049 11.8422 2.95905 11.1718 3.0654L10.3842 3.19034C10.0036 3.25071 9.61882 3.11066 9.3661 2.8198L8.84307 2.21783C8.39783 1.70538 7.60217 1.70539 7.15693 2.21783L6.63389 2.8198C6.38118 3.11066 5.99639 3.25071 5.61584 3.19034Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  faq: (props: IconProps) => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask id="path-1-inside-1_3_7794" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99998 2.99365C4.87037 2.99365 2.33331 5.53071 2.33331 8.66032C2.33331 11.7899 4.87037 14.327 7.99998 14.327C11.1296 14.327 13.6666 11.7899 13.6666 8.66032C13.6666 5.53071 11.1296 2.99365 7.99998 2.99365ZM1.33331 8.66032C1.33331 4.97842 4.31808 1.99365 7.99998 1.99365C11.6819 1.99365 14.6666 4.97842 14.6666 8.66032C14.6666 12.3422 11.6819 15.327 7.99998 15.327C4.31808 15.327 1.33331 12.3422 1.33331 8.66032Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.25762 6.33977C7.75249 6.30525 7.27214 6.5438 7.10366 6.88284C6.98076 7.13013 6.68067 7.23097 6.43338 7.10808C6.18609 6.98518 6.08525 6.68509 6.20814 6.4378C6.60972 5.62973 7.55141 5.28917 8.3258 5.3421C8.72726 5.36953 9.14215 5.50337 9.46532 5.78661C9.80035 6.08025 9.99998 6.50363 9.99998 7.0212C9.99998 7.79515 9.47669 8.25333 9.13287 8.55435C9.11497 8.57003 9.09756 8.58528 9.08073 8.60012C8.69102 8.94387 8.49998 9.1482 8.49998 9.49365C8.49998 9.76979 8.27612 9.99365 7.99998 9.99365C7.72384 9.99365 7.49998 9.76979 7.49998 9.49365C7.49998 8.66042 8.04097 8.18358 8.40156 7.86575C8.4075 7.86052 8.41339 7.85532 8.41923 7.85017C8.82919 7.48857 8.99998 7.31328 8.99998 7.0212C8.99998 6.77921 8.91536 6.63432 8.8062 6.53865C8.68517 6.43257 8.49593 6.35605 8.25762 6.33977Z"
        />
        <path d="M7.33331 11.327C7.33331 10.9588 7.63179 10.6603 7.99998 10.6603C8.36817 10.6603 8.66665 10.9588 8.66665 11.327C8.66665 11.6952 8.36817 11.9937 7.99998 11.9937C7.63179 11.9937 7.33331 11.6952 7.33331 11.327Z" />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99998 2.99365C4.87037 2.99365 2.33331 5.53071 2.33331 8.66032C2.33331 11.7899 4.87037 14.327 7.99998 14.327C11.1296 14.327 13.6666 11.7899 13.6666 8.66032C13.6666 5.53071 11.1296 2.99365 7.99998 2.99365ZM1.33331 8.66032C1.33331 4.97842 4.31808 1.99365 7.99998 1.99365C11.6819 1.99365 14.6666 4.97842 14.6666 8.66032C14.6666 12.3422 11.6819 15.327 7.99998 15.327C4.31808 15.327 1.33331 12.3422 1.33331 8.66032Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25762 6.33977C7.75249 6.30525 7.27214 6.5438 7.10366 6.88284C6.98076 7.13013 6.68067 7.23097 6.43338 7.10808C6.18609 6.98518 6.08525 6.68509 6.20814 6.4378C6.60972 5.62973 7.55141 5.28917 8.3258 5.3421C8.72726 5.36953 9.14215 5.50337 9.46532 5.78661C9.80035 6.08025 9.99998 6.50363 9.99998 7.0212C9.99998 7.79515 9.47669 8.25333 9.13287 8.55435C9.11497 8.57003 9.09756 8.58528 9.08073 8.60012C8.69102 8.94387 8.49998 9.1482 8.49998 9.49365C8.49998 9.76979 8.27612 9.99365 7.99998 9.99365C7.72384 9.99365 7.49998 9.76979 7.49998 9.49365C7.49998 8.66042 8.04097 8.18358 8.40156 7.86575C8.4075 7.86052 8.41339 7.85532 8.41923 7.85017C8.82919 7.48857 8.99998 7.31328 8.99998 7.0212C8.99998 6.77921 8.91536 6.63432 8.8062 6.53865C8.68517 6.43257 8.49593 6.35605 8.25762 6.33977Z"
        fill="black"
      />
      <path
        d="M7.33331 11.327C7.33331 10.9588 7.63179 10.6603 7.99998 10.6603C8.36817 10.6603 8.66665 10.9588 8.66665 11.327C8.66665 11.6952 8.36817 11.9937 7.99998 11.9937C7.63179 11.9937 7.33331 11.6952 7.33331 11.327Z"
        fill="black"
      />
      <path
        d="M7.10366 6.88284L7.99917 7.32787V7.32787L7.10366 6.88284ZM8.25762 6.33977L8.18944 7.33744L8.25762 6.33977ZM6.20814 6.4378L5.31263 5.99277V5.99277L6.20814 6.4378ZM8.3258 5.3421L8.39398 4.34442L8.3258 5.3421ZM9.46532 5.78661L8.8062 6.53865L9.46532 5.78661ZM9.13287 8.55435L8.47413 7.80199L8.47413 7.80199L9.13287 8.55435ZM9.08073 8.60012L9.74222 9.35007L9.74223 9.35007L9.08073 8.60012ZM8.40156 7.86575L7.74034 7.11556L7.74033 7.11557L8.40156 7.86575ZM8.41923 7.85017L9.08073 8.60012L9.08073 8.60012L8.41923 7.85017ZM8.8062 6.53865L9.46532 5.78661V5.78661L8.8062 6.53865ZM3.33331 8.66032C3.33331 6.08299 5.42265 3.99365 7.99998 3.99365V1.99365C4.31808 1.99365 1.33331 4.97842 1.33331 8.66032H3.33331ZM7.99998 13.327C5.42265 13.327 3.33331 11.2376 3.33331 8.66032H1.33331C1.33331 12.3422 4.31808 15.327 7.99998 15.327V13.327ZM12.6666 8.66032C12.6666 11.2376 10.5773 13.327 7.99998 13.327V15.327C11.6819 15.327 14.6666 12.3422 14.6666 8.66032H12.6666ZM7.99998 3.99365C10.5773 3.99365 12.6666 6.08299 12.6666 8.66032H14.6666C14.6666 4.97842 11.6819 1.99365 7.99998 1.99365V3.99365ZM7.99998 0.993652C3.7658 0.993652 0.333313 4.42614 0.333313 8.66032H2.33331C2.33331 5.53071 4.87037 2.99365 7.99998 2.99365V0.993652ZM15.6666 8.66032C15.6666 4.42614 12.2342 0.993652 7.99998 0.993652V2.99365C11.1296 2.99365 13.6666 5.53071 13.6666 8.66032H15.6666ZM7.99998 16.327C12.2342 16.327 15.6666 12.8945 15.6666 8.66032H13.6666C13.6666 11.7899 11.1296 14.327 7.99998 14.327V16.327ZM0.333313 8.66032C0.333313 12.8945 3.7658 16.327 7.99998 16.327V14.327C4.87037 14.327 2.33331 11.7899 2.33331 8.66032H0.333313ZM7.99917 7.32787C7.97812 7.37023 7.95783 7.389 7.95588 7.39077C7.95367 7.39277 7.96238 7.38458 7.98585 7.37336C8.03573 7.3495 8.1101 7.33202 8.18944 7.33744L8.3258 5.3421C7.5431 5.28861 6.60678 5.63565 6.20814 6.4378L7.99917 7.32787ZM5.98835 8.00359C6.73022 8.37227 7.63049 8.06974 7.99917 7.32787L6.20814 6.4378C6.33104 6.19051 6.63113 6.08967 6.87842 6.21256L5.98835 8.00359ZM5.31263 5.99277C4.94395 6.73464 5.24648 7.63491 5.98835 8.00359L6.87842 6.21256C7.1257 6.33545 7.22655 6.63555 7.10366 6.88284L5.31263 5.99277ZM8.39398 4.34442C7.3548 4.27341 5.94886 4.71251 5.31263 5.99277L7.10366 6.88284C7.27058 6.54695 7.74802 6.30494 8.25762 6.33977L8.39398 4.34442ZM10.1244 5.03458C9.59882 4.57389 8.95808 4.38297 8.39398 4.34442L8.25762 6.33977C8.49645 6.35609 8.68548 6.43285 8.8062 6.53865L10.1244 5.03458ZM11 7.0212C11 6.22834 10.6855 5.52636 10.1244 5.03458L8.8062 6.53865C8.91515 6.63414 8.99998 6.77893 8.99998 7.0212H11ZM9.79162 9.30672C10.1102 9.02777 11 8.29654 11 7.0212H8.99998C8.99998 7.29376 8.84316 7.47888 8.47413 7.80199L9.79162 9.30672ZM9.74223 9.35007C9.75744 9.33665 9.77344 9.32264 9.79162 9.30672L8.47413 7.80199C8.4565 7.81742 8.43768 7.8339 8.41923 7.85018L9.74223 9.35007ZM9.49998 9.49365C9.49998 9.50282 9.49818 9.53153 9.48603 9.56854C9.47425 9.60444 9.46079 9.62349 9.46229 9.62135C9.46632 9.61562 9.48442 9.59167 9.53356 9.5424C9.58301 9.49283 9.64859 9.43266 9.74222 9.35007L8.41923 7.85017C8.0633 8.16412 7.49998 8.64432 7.49998 9.49365H9.49998ZM7.99998 10.9937C8.82841 10.9937 9.49998 10.3221 9.49998 9.49365H7.49998C7.49998 9.21751 7.72384 8.99365 7.99998 8.99365V10.9937ZM6.49998 9.49365C6.49998 10.3221 7.17155 10.9937 7.99998 10.9937V8.99365C8.27612 8.99365 8.49998 9.21751 8.49998 9.49365H6.49998ZM7.74033 7.11557C7.3951 7.41986 6.49998 8.16662 6.49998 9.49365H8.49998C8.49998 9.15423 8.68684 8.94731 9.06279 8.61594L7.74033 7.11557ZM7.75774 7.10022C7.75205 7.10524 7.74629 7.11031 7.74034 7.11556L9.06279 8.61594C9.06871 8.61072 9.07473 8.60541 9.08073 8.60012L7.75774 7.10022ZM7.99998 7.0212C7.99998 6.99194 8.00506 6.94333 8.02449 6.8886C8.04284 6.8369 8.06357 6.80931 8.06271 6.81046C8.05902 6.81539 8.03946 6.83987 7.98469 6.8933C7.93024 6.9464 7.85878 7.0111 7.75774 7.10022L9.08073 8.60012C9.27072 8.43253 9.49747 8.23126 9.66397 8.00877C9.87013 7.73329 9.99998 7.41031 9.99998 7.0212H7.99998ZM8.14707 7.29068C8.10591 7.2546 8.06081 7.20015 8.02997 7.13064C8.00011 7.06335 7.99998 7.01877 7.99998 7.0212H9.99998C9.99998 6.50288 9.7998 6.07977 9.46532 5.78661L8.14707 7.29068ZM8.18944 7.33744C8.22118 7.33961 8.23234 7.3447 8.2262 7.3424C8.22122 7.34054 8.18987 7.32819 8.14707 7.29068L9.46532 5.78661C9.14282 5.50395 8.72836 5.36961 8.3258 5.3421L8.18944 7.33744ZM7.99998 10.9937C8.18407 10.9937 8.33331 11.1429 8.33331 11.327H6.33331C6.33331 12.2475 7.07951 12.9937 7.99998 12.9937V10.9937ZM7.66665 11.327C7.66665 11.1429 7.81589 10.9937 7.99998 10.9937V12.9937C8.92045 12.9937 9.66665 12.2475 9.66665 11.327H7.66665ZM7.99998 11.6603C7.81589 11.6603 7.66665 11.5111 7.66665 11.327H9.66665C9.66665 10.4065 8.92045 9.66032 7.99998 9.66032V11.6603ZM7.99998 9.66032C7.07951 9.66032 6.33331 10.4065 6.33331 11.327H8.33331C8.33331 11.5111 8.18407 11.6603 7.99998 11.6603V9.66032Z"
        fill="white"
        mask="url(#path-1-inside-1_3_7794)"
      />
    </svg>
  ),
  quote: (props: IconProps) => (
    <svg
      width="104"
      height="118"
      viewBox="0 0 104 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g transform="translate(-7,0)">
        <rect
          x="14"
          width="90"
          height="90"
          rx="45"
          fill="white"
          fillOpacity="0.04"
        />
        <rect
          x="14.5"
          y="0.5"
          width="89"
          height="89"
          rx="44.5"
          stroke="white"
          strokeOpacity="0.05"
        />
        <g filter="url(#filter0_di_3_3854)">
          <g clipPath="url(#clip0_3_3854)">
            <rect x="24" y="10" width="70" height="70" rx="35" fill="#1E1E21" />
            <g filter="url(#filter1_f_3_3854)">
              <path
                d="M1 132.234L152.591 213.782L203.68 39.8228L117.998 -6.26903L1 132.234Z"
                fill="url(#paint0_linear_3_3854)"
                fillOpacity="0.1"
              />
            </g>
            <g filter="url(#filter2_d_3_3854)">
              <path
                d="M74.1325 36.8466V43.4711C74.1325 45.3762 73.7753 47.3571 73.0609 49.4137C72.3248 51.492 71.329 53.4512 70.0734 55.2914C68.7961 57.1532 67.3673 58.7227 65.7869 60L60.3314 56.4604C61.6087 54.5337 62.6803 52.5203 63.5462 50.4204C64.3905 48.3421 64.8019 46.0473 64.7802 43.5361V36.8466H74.1325ZM57.6686 36.8466V43.4711C57.6686 45.3762 57.3114 47.3571 56.597 49.4137C55.8609 51.492 54.8651 53.4512 53.6094 55.2914C52.3322 57.1532 50.9033 58.7227 49.323 60L43.8675 56.4604C45.1447 54.5337 46.2164 52.5203 47.0823 50.4204C47.9266 48.3421 48.3379 46.0473 48.3163 43.5361V36.8466H57.6686Z"
                fill="#E6E6E6"
              />
              <path
                d="M74.1325 36.8466V43.4711C74.1325 45.3762 73.7753 47.3571 73.0609 49.4137C72.3248 51.492 71.329 53.4512 70.0734 55.2914C68.7961 57.1532 67.3673 58.7227 65.7869 60L60.3314 56.4604C61.6087 54.5337 62.6803 52.5203 63.5462 50.4204C64.3905 48.3421 64.8019 46.0473 64.7802 43.5361V36.8466H74.1325ZM57.6686 36.8466V43.4711C57.6686 45.3762 57.3114 47.3571 56.597 49.4137C55.8609 51.492 54.8651 53.4512 53.6094 55.2914C52.3322 57.1532 50.9033 58.7227 49.323 60L43.8675 56.4604C45.1447 54.5337 46.2164 52.5203 47.0823 50.4204C47.9266 48.3421 48.3379 46.0473 48.3163 43.5361V36.8466H57.6686Z"
                fill="url(#paint1_linear_3_3854)"
              />
            </g>
          </g>
          <rect
            x="24.5"
            y="10.5"
            width="69"
            height="69"
            rx="34.5"
            stroke="url(#paint2_linear_3_3854)"
            strokeOpacity="0.55"
          />
        </g>
        <defs>
          <filter
            id="filter0_di_3_3854"
            x="0"
            y="10"
            width="98"
            height="108"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feMorphology
              radius="10"
              operator="erode"
              in="SourceAlpha"
              result="effect1_dropShadow_3_3854"
            />
            <feOffset dx="-10" dy="24" />
            <feGaussianBlur stdDeviation="12" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3_3854"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3_3854"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="7" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect2_innerShadow_3_3854"
            />
          </filter>
          <filter
            id="filter1_f_3_3854"
            x="-34.0491"
            y="-41.3181"
            width="272.778"
            height="290.149"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="17.5245"
              result="effect1_foregroundBlur_3_3854"
            />
          </filter>
          <filter
            id="filter2_d_3_3854"
            x="25.8675"
            y="26.8467"
            width="58.265"
            height="51.1533"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-4" dy="4" />
            <feGaussianBlur stdDeviation="7" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3_3854"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3_3854"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_3_3854"
            x1="76.7953"
            y1="173.008"
            x2="143.375"
            y2="42.1291"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_3_3854"
            x1="59"
            y1="60"
            x2="59"
            y2="36.8466"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#999999" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_3_3854"
            x1="84.7895"
            y1="12.7632"
            x2="59"
            y2="80"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0.1" />
          </linearGradient>
          <clipPath id="clip0_3_3854">
            <rect x="24" y="10" width="70" height="70" rx="35" fill="white" />
          </clipPath>
        </defs>
      </g>
    </svg>
  ),
};

export const AboutIcons = {
  mission: (props: IconProps) => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.86736 7.13265L7.52789 9.86641L9.00087 7.47057L11.8049 7.68714L9.98154 5.5459L11.054 2.94599L8.45412 4.01847L6.31287 2.19507L6.52944 4.99914L4.13361 6.47212L6.86736 7.13265ZM6.86736 7.13265L2.1875 11.8125"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  ),
  evolution: (props: IconProps) => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.25 9.84375H10.5C10.9641 9.84375 11.4092 9.65938 11.7374 9.33119C12.0656 9.003 12.25 8.55788 12.25 8.09375C12.25 7.62962 12.0656 7.1845 11.7374 6.85631C11.4092 6.52812 10.9641 6.34375 10.5 6.34375H4.375C3.91087 6.34375 3.46575 6.15938 3.13756 5.83119C2.80937 5.503 2.625 5.05788 2.625 4.59375C2.625 4.12962 2.80937 3.6845 3.13756 3.35631C3.46575 3.02812 3.91087 2.84375 4.375 2.84375H7.21175M3.9375 8.75C4.2856 8.75 4.61944 8.88828 4.86558 9.13442C5.11172 9.38056 5.25 9.7144 5.25 10.0625C5.25 10.4106 5.11172 10.7444 4.86558 10.9906C4.61944 11.2367 4.2856 11.375 3.9375 11.375C3.5894 11.375 3.25556 11.2367 3.00942 10.9906C2.76328 10.7444 2.625 10.4106 2.625 10.0625C2.625 9.7144 2.76328 9.38056 3.00942 9.13442C3.25556 8.88828 3.5894 8.75 3.9375 8.75ZM8.75 1.75C8.92236 1.75 9.09303 1.78395 9.25227 1.84991C9.41151 1.91587 9.5562 2.01255 9.67808 2.13442C9.79995 2.2563 9.89663 2.40099 9.96259 2.56023C10.0286 2.71947 10.0625 2.89014 10.0625 3.0625C10.0625 3.23486 10.0286 3.40553 9.96259 3.56477C9.89663 3.72401 9.79995 3.8687 9.67808 3.99058C9.5562 4.11245 9.41151 4.20913 9.25227 4.27509C9.09303 4.34105 8.92236 4.375 8.75 4.375C8.4019 4.375 8.06806 4.23672 7.82192 3.99058C7.57578 3.74444 7.4375 3.4106 7.4375 3.0625C7.4375 2.7144 7.57578 2.38056 7.82192 2.13442C8.06806 1.88828 8.4019 1.75 8.75 1.75Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  ),
  founded: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        d="M4.80005 19H14.8M4.80005 19V4H14.8V8M4.80005 19H2.80005M20.8 19H14.8M20.8 19V8H14.8M20.8 19H22.8M14.8 19V8M10.8 9H8.80005M8.80005 13H10.8"
        stroke="url(#paint0_radial_567_15522)"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <defs>
        <radialGradient
          id="paint0_radial_567_15522"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.8001 3.28571) rotate(90) scale(26.0714 34.7619)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.06" />
        </radialGradient>
      </defs>
    </svg>
  ),
  launched: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        d="M4.40015 13C6.18324 13.2119 7.84319 14.0175 9.1129 15.2872C10.3826 16.557 11.1882 18.2169 11.4001 20C12.2841 19.4904 13.0234 18.7638 13.5484 17.8889C14.0733 17.014 14.3665 16.0197 14.4001 15C16.0793 14.4093 17.5455 13.334 18.6135 11.91C19.6815 10.486 20.3032 8.77734 20.4001 7C20.4001 6.20435 20.0841 5.44129 19.5215 4.87868C18.9589 4.31607 18.1958 4 17.4001 4C15.6228 4.09691 13.9141 4.71867 12.4901 5.78665C11.0662 6.85464 9.99083 8.32089 9.40015 10C8.38041 10.0337 7.3861 10.3268 6.51121 10.8518C5.63632 11.3767 4.90974 12.1161 4.40015 13Z"
        stroke="url(#paint0_radial_567_7350)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.40014 14C6.35937 14.5876 5.51779 15.4726 4.9833 16.5416C4.4488 17.6106 4.24573 18.8148 4.40014 20C5.5853 20.1544 6.78956 19.9513 7.85856 19.4168C8.92756 18.8823 9.81257 18.0408 10.4001 17M14.4001 9C14.4001 9.26522 14.5055 9.51957 14.693 9.70711C14.8806 9.89464 15.1349 10 15.4001 10C15.6654 10 15.9197 9.89464 16.1072 9.70711C16.2948 9.51957 16.4001 9.26522 16.4001 9C16.4001 8.73478 16.2948 8.48043 16.1072 8.29289C15.9197 8.10536 15.6654 8 15.4001 8C15.1349 8 14.8806 8.10536 14.693 8.29289C14.5055 8.48043 14.4001 8.73478 14.4001 9Z"
        stroke="url(#paint1_radial_567_7350)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <radialGradient
          id="paint0_radial_567_7350"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.4001 3.23809) rotate(90) scale(27.8095)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.06" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_567_7350"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.375 7.42618) rotate(90) scale(20.9445)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.06" />
        </radialGradient>
      </defs>
    </svg>
  ),
  introducedAdvanced: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M21 12V5H3V20H12M20.5 16L14 14L16 20.5L17.5 17.5L20.5 16Z"
        stroke="url(#paint0_radial_567_15524)"
        strokeWidth="2"
      />
      <path
        d="M5.875 8.75C5.875 9.23325 6.26675 9.625 6.75 9.625C7.23325 9.625 7.625 9.23325 7.625 8.75C7.625 8.26675 7.23325 7.875 6.75 7.875C6.26675 7.875 5.875 8.26675 5.875 8.75ZM9.375 8.75C9.375 9.23325 9.76675 9.625 10.25 9.625C10.7332 9.625 11.125 9.23325 11.125 8.75C11.125 8.26675 10.7332 7.875 10.25 7.875C9.76675 7.875 9.375 8.26675 9.375 8.75ZM12.875 8.75C12.875 9.23325 13.2668 9.625 13.75 9.625C14.2332 9.625 14.625 9.23325 14.625 8.75C14.625 8.26675 14.2332 7.875 13.75 7.875C13.2668 7.875 12.875 8.26675 12.875 8.75Z"
        fill="white"
        stroke="white"
        strokeWidth="0.75"
        strokeLinecap="square"
      />
      <defs>
        <radialGradient
          id="paint0_radial_567_15524"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12 4.2619) rotate(90) scale(26.9405 31.2857)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.06" />
        </radialGradient>
      </defs>
    </svg>
  ),
  expandedGlobally: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        d="M21.6001 12C21.6001 16.9706 17.5707 21 12.6001 21M21.6001 12C21.6001 7.02944 17.5707 3 12.6001 3M21.6001 12H3.6001M12.6001 21C7.62953 21 3.6001 16.9706 3.6001 12M12.6001 21C10.391 21 8.6001 16.9706 8.6001 12C8.6001 7.02944 10.391 3 12.6001 3M12.6001 21C14.8092 21 16.6001 16.9706 16.6001 12C16.6001 7.02944 14.8092 3 12.6001 3M3.6001 12C3.6001 7.02944 7.62953 3 12.6001 3"
        stroke="url(#paint0_radial_567_15527)"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <defs>
        <radialGradient
          id="paint0_radial_567_15527"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.6001 2.14286) rotate(90) scale(31.2857)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.06" />
        </radialGradient>
      </defs>
    </svg>
  ),
  recognized: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        d="M8.2002 22H7.2002V23.618L8.64741 22.8944L8.2002 22ZM12.2002 20L12.6474 19.1056L12.2002 18.882L11.753 19.1056L12.2002 20ZM16.2002 22L15.753 22.8944L17.2002 23.618V22H16.2002ZM17.2002 15V14H15.2002V15H17.2002ZM7.2002 15V22H9.2002V15H7.2002ZM8.64741 22.8944L12.6474 20.8944L11.753 19.1056L7.75298 21.1056L8.64741 22.8944ZM11.753 20.8944L15.753 22.8944L16.6474 21.1056L12.6474 19.1056L11.753 20.8944ZM17.2002 22V15H15.2002V22H17.2002ZM18.2002 9C18.2002 12.3137 15.5139 15 12.2002 15V17C16.6185 17 20.2002 13.4183 20.2002 9H18.2002ZM12.2002 15C8.88649 15 6.2002 12.3137 6.2002 9H4.2002C4.2002 13.4183 7.78192 17 12.2002 17V15ZM6.2002 9C6.2002 5.68629 8.88649 3 12.2002 3V1C7.78192 1 4.2002 4.58172 4.2002 9H6.2002ZM12.2002 3C15.5139 3 18.2002 5.68629 18.2002 9H20.2002C20.2002 4.58172 16.6185 1 12.2002 1V3Z"
        fill="url(#paint0_radial_567_15529)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_567_15529"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.2002 1.04762) rotate(90) scale(34.7619 24.3333)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.06" />
        </radialGradient>
      </defs>
    </svg>
  ),
  awardsRecognitions: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_567_15531)">
        <path
          d="M4.52075 12.8333H3.77075V14.0151L4.8401 13.5119L4.52075 12.8333ZM6.99992 11.6666L7.31927 10.988L6.99992 10.8377L6.68057 10.988L6.99992 11.6666ZM9.47909 12.8333L9.15974 13.5119L10.2291 14.0151V12.8333H9.47909ZM10.2291 8.74992V7.99992H8.72909V8.74992H10.2291ZM3.77075 8.74992V12.8333H5.27075V8.74992H3.77075ZM4.8401 13.5119L7.31927 12.3452L6.68057 10.988L4.2014 12.1546L4.8401 13.5119ZM6.68057 12.3452L9.15974 13.5119L9.79843 12.1546L7.31927 10.988L6.68057 12.3452ZM10.2291 12.8333V8.74992H8.72909V12.8333H10.2291ZM10.4791 5.24992C10.4791 7.17141 8.92141 8.72908 6.99992 8.72908V10.2291C9.74984 10.2291 11.9791 7.99984 11.9791 5.24992H10.4791ZM6.99992 8.72908C5.07843 8.72908 3.52075 7.17141 3.52075 5.24992H2.02075C2.02075 7.99984 4.25 10.2291 6.99992 10.2291V8.72908ZM3.52075 5.24992C3.52075 3.32843 5.07843 1.77075 6.99992 1.77075V0.270752C4.25 0.270752 2.02075 2.5 2.02075 5.24992H3.52075ZM6.99992 1.77075C8.92141 1.77075 10.4791 3.32843 10.4791 5.24992H11.9791C11.9791 2.5 9.74984 0.270752 6.99992 0.270752V1.77075Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_567_15531">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  bestAiPoweredSurveyPlatform: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      {...props}
    >
      <path
        d="M19.6001 6.09998C19.6001 7.48069 16.4661 8.59998 12.6001 8.59998C8.7341 8.59998 5.6001 7.48069 5.6001 6.09998M19.6001 6.09998C19.6001 4.71926 16.4661 3.59998 12.6001 3.59998C8.7341 3.59998 5.6001 4.71926 5.6001 6.09998M19.6001 6.09998V19.1C19.6001 20.4807 16.4661 21.6 12.6001 21.6C8.7341 21.6 5.6001 20.4807 5.6001 19.1V6.09998M19.6001 12.6C19.6001 13.9807 16.4661 15.1 12.6001 15.1C8.7341 15.1 5.6001 13.9807 5.6001 12.6"
        stroke="url(#paint0_radial_567_15533)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <radialGradient
          id="paint0_radial_567_15533"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.6001 2.74283) rotate(90) scale(31.2857 24.3333)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.06" />
        </radialGradient>
      </defs>
    </svg>
  ),
  topInnovatorAIAnalytics: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      {...props}
    >
      <path
        d="M4.26685 12.6C8.26685 11.1 10.7668 8.59998 12.2668 4.59998C13.7668 8.59998 16.2668 11.1 20.2668 12.6C16.2668 14.1 13.7668 16.6 12.2668 20.6C10.7668 16.6 8.26685 14.1 4.26685 12.6Z"
        stroke="url(#paint0_radial_567_15535)"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <defs>
        <radialGradient
          id="paint0_radial_567_15535"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.2668 3.83807) rotate(90) scale(27.8095)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.06" />
        </radialGradient>
      </defs>
    </svg>
  ),
  mostAdvancedDataInsightsPlatform: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      {...props}
    >
      <path
        d="M10.2636 20.6V14.6H4.93359V20.6H10.2636ZM10.2636 20.6H15.5936M10.2636 20.6V4.59998H15.5936V20.6M15.5936 20.6H20.9236V9.59998H15.5936V20.6Z"
        stroke="url(#paint0_radial_567_15537)"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <defs>
        <radialGradient
          id="paint0_radial_567_15537"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.9286 3.83807) rotate(90) scale(27.8095 27.7921)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.06" />
        </radialGradient>
      </defs>
    </svg>
  ),
  university: (props: IconProps) => (
    <svg
      width="18"
      height="20"
      viewBox="-4 -1 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 19H17M3 16L3 8M7 16L7 8M11 16V8M15 16V8M1 8H17V4.5L9 2L1 4.5V8Z"
        stroke="url(#paint0_radial_567_15537)"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <defs>
        <radialGradient
          id="paint0_radial_567_15537"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.9286 3.83807) rotate(90) scale(27.8095 27.7921)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.06" />
        </radialGradient>
      </defs>
    </svg>
  ),
};
